module.exports = __webpack_public_path__ + "2635ab518b71cfe3d4241741689d8894.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Material-Design-Icons.ttf?-g7cqhn
// module id = 1549
// module chunks = 0